import { makeAutoObservable } from "mobx";
import DataLoading from 'react-sdk/DataLoading';
import ScaleManager from "react-sdk/ScaleManager";
// import SequencesManager, { SequencesFile } from 'react-sdk/SequencesManager';
import Texts from "react-sdk/Texts";
import { getUrlVar } from "react-sdk/utils";
import DownloadableFiles from "./DownloadableFiles";
import SoundPlayer from "./SoundPlayer";
import PresentationHelper from "./PresentationHelper";
import Personnages from "react-sdk/Personnage/Personnages";
import SpeechHelper from "./SpeechHelper";

export const SCREENS = {
  LOADING : "LOADING",
  INTRO : "INTRO",
  PRESENTATION : "PRESENTATION"
}

export const POPUPS = {
  MENTION_LEGALES: "MENTION_LEGALES",
  TRAILER: "TRAILER",
  SETTINGS: "SETTINGS",
  CREDITS: "CREDITS",
  CONTACT: "CONTACT"
}

class AppState {
  debugMode = false
  language = "en"
  files_root = "./data/"
  screen = SCREENS.LOADING

  gameReady = false

  popup = null
  loaderOverlay = false

  vertxApi = null

  // settings ici
  subtitles_visible = true
  sound = true

  paused = false
  phaseEndCallback = null

  constructor() {
    this.debugMode = getUrlVar("debug")
    this.language = getUrlVar("language")
    this.files_root += getUrlVar("sequence") + '/'


    if(!window.CONFIG.supported_languages.includes(this.language)) {
      
      console.error("unsupported language \"" + this.language + "\" please use one of the followings : " + window.CONFIG.supported_languages)
      console.error("English language will be set")
      
      this.language = window.CONFIG.supported_languages[0]
    } 


    /** @type <ScormAdapter> */
    this.scormAdapter = null

    ScaleManager.init(1920, 1080)
   
    this.loaderOverlay = true

    Personnages.waitEngineInit()
    .then(() => DataLoading.getAllFiles(window.CONFIG.requiredFiles, this.files_root))
    // .then(() => DataLoading.getAllFiles({ character_file: "little-philosophers.char"}, "./"))
    .then(files => {
      SoundPlayer.init(files.audio)
      Texts.init(files.texts, this.language)
      // Faq.init(files.faq)
      DownloadableFiles.init(files.fichiers_telechargeables)
      PresentationHelper.init(files.sequence, this.files_root)
      PresentationHelper.initVues(files.vues)
    })
    .then(() => this.loadReactHomeCharacter())
    .then(() => this.launchIntro())

    makeAutoObservable(this, { vertxApi: false })
  }

  setScreen(id, data = null) {
    this.screenData = data
    this.screen = id
  }

  setPopup(popup_id) { this.popup = popup_id }

  setPause(val) {
    this.paused = val

    if(val) {
      SoundPlayer.pause()
    }
    else {
      SoundPlayer.unpause()
    }
  }

  loadReactHomeCharacter() {
    return new Promise( (resolve, reject) => {
    
      resolve()
    })
  }

  launchIntro() {
    this.loaderOverlay = false
    this.setScreen(SCREENS.INTRO)
  }

  launchModule() {
    this.loaderOverlay = true

    this.setScreen(SCREENS.PRESENTATION)   
    this.phaseEndCallback = () => this.quit()
  }

  restart() {
    window.location.reload()
  }

  quit() {
    window.close()
    // var win = window.self;
    // win.opener = window.self;
    // win.close();
  }

}


export default new AppState()
